import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = /*#__PURE__*/_createElementVNode("em", {
  class: "c-video-play"
}, null, -1);
const _hoisted_2 = [_hoisted_1];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    class: "c-video",
    style: _normalizeStyle($options.styles),
    onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('click'))
  }, _hoisted_2, 4);
}